import React, { useContext, useState } from "react";
import { FilterContext } from "./context";
import { Tooltip } from "@mui/material";
import { OwcButton, OwcIconButton } from "@one/react";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import ConfirmDialog from "../../../../components/shared/ConfirmDialog";
import { removeFilterAssignment } from "../removeFilterAssignment";
import {withApollo} from "react-apollo";
import { ACTIONS_ROW_STYLE } from "../../components/tableMetaHelpers";

const Actions = ({ item, client, triggerRefresh, setTriggerRefresh }) => {
    const { setDialogOpen, setIsEditMode, setEditData } = useContext(FilterContext);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
      setIsDeleting(true);
      try {
        await removeFilterAssignment({
          client,
          filterName: item.filterName,
          filterUserID: item.userID,
          columnSetName: item.columnSet,
          columnSetUserID: item.columnSetOwnerId || item.userID,
          groupIds: item.sharedWithGroups,
        });

        snackbarService.show({
          message: "Assignment removed successfully.",
          type: "success",
        });
        setIsDeleteDialogOpen(false);
        if (setTriggerRefresh) {
          triggerRefresh();
        }
      } catch (err) {
        console.error("Error removing assignment:", err);
        snackbarService.show({
          message: "Failed to remove assignment.",
          type: "error",
        });
      } finally {
        setIsDeleting(false);
      }
    };

    return (
        <>
      <div style={ACTIONS_ROW_STYLE}>
            <Tooltip
                data-testid={`filter-edit-button-tooltip${item.groupName}`}
                title="Edit assignment"
                placement="left"
                arrow
            >
                <OwcIconButton
                    key={`booking-admin-table-edit-filter-button-${item.groupName}`}
                    data-testid={`booking-admin-table-edit-filter-button-${item.groupName}`}
                    onClick={() => {
                        setIsEditMode(true);
                        const assignedGroupsArray = item.assignedGroups && item.assignedGroups !== "-"
                            ? item.assignedGroups.split(", ").map(group => group.trim())
                            : [];
                        const editData = {
                            filter: {
                              filterName: item.filterName,
                              id: item.id,
                              userID: item.userID,
                              __typename:"UserFilter"
                            },
                            columnSet: {
                              displayName: item.columnSet,
                              id: item.id,
                              userID: item.columnSetOwnerId,
                              __typename:"UserDisplay"
                            },
                            groups: assignedGroupsArray
                        };

                        if (setEditData) {
                            setEditData(editData);
                        }

                        setDialogOpen(true);
                    }}
                    icon="edit"
                    type="legacy"
                    flat
                />
            </Tooltip>

          <Tooltip title="Remove assignment" placement="left" arrow>
            <OwcIconButton
              key={`booking-admin-table-delete-filter-button-${item.groupName}`}
              data-testid={`booking-admin-table-delete-filter-button-${item.groupName}`}
              icon="delete"
              type="legacy"
              flat
              onClick={() => setIsDeleteDialogOpen(true)}
            />
          </Tooltip>
        </div>
        <ConfirmDialog
          open={isDeleteDialogOpen}
          close={() => setIsDeleteDialogOpen(false)}
          onCancel={() => setIsDeleteDialogOpen(false)}
          title="Remove filter assignment"
          renderActions={() => (
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
              <OwcButton variant="secondary" flat onClick={() => setIsDeleteDialogOpen(false)}>
                Cancel
              </OwcButton>
              <OwcButton variant="primary" flat disabled={isDeleting} onClick={handleDelete}>
                Remove
              </OwcButton>
            </div>
          )}
        >
          <div>
            This will remove the selected filter assignment from all listed booking groups.
          </div>
        </ConfirmDialog>
        </>
    );
};

export default withApollo(Actions);
